import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import {
  Box,
  CheckboxGroup,
  Grid,
  Checkbox,
  Typography,
  FormLabel,
  useThemedValueSwitch,
  FormControl,
} from '@tq/ui-components';
import { useRecoilState } from 'recoil';

import { ConsultationTypeCount, useConsultations, useFilterConsultationTypes } from 'api';
import { filterConsultationTypeState } from 'store';

let consultationTypeCounts: ConsultationTypeCount[];

export const ConsultationTypeFilter: React.FC = () => {
  const { t } = useTranslation('filter');
  const { tvs } = useThemedValueSwitch();

  const [selectedItems, setSelectedItems] = useRecoilState(filterConsultationTypeState);

  const { data: typeData } = useFilterConsultationTypes();
  const { data: consultationsData } = useConsultations();

  const consultationTypes = typeData?.consultationTypes || [];

  consultationTypes.sort((a, b) => {
    if (a.orderPosition !== undefined && b.orderPosition !== undefined) {
      return a.orderPosition - b.orderPosition;
    }

    return 0;
  });

  if (consultationsData) {
    consultationTypeCounts = consultationsData.consultationTypeCounts;
  }

  const getTypeCount = (consultationTypeId: number): number =>
    consultationTypeCounts?.find(
      (consultationTypeCount) =>
        consultationTypeCount.consultationTypeId === consultationTypeId
    )?.count ?? 0;

  const toggleSelectedType = (event: React.ChangeEvent<HTMLInputElement>) => {
    const activeType = typeData?.consultationTypes.find(
      (x) => x.value === +event.target.value
    );
    setSelectedItems(
      event.target.checked && activeType
        ? [...selectedItems.filter((type) => type.value !== +event.target.value), activeType]
        : selectedItems.filter((type) => type.value !== +event.target.value)
    );
  };

  return (
    <Grid>
      <FormControl>
        <FormLabel id='type_label'>{t('consultation_type', 'Consultation type')}:</FormLabel>
        <CheckboxGroup
          aria-labelledby='type_label'
          value={selectedItems?.map((type) => type.value)}
        >
          {consultationTypes.map((filter) => (
            <Box
              key={filter.value}
              borderBottom='1px solid'
              borderColor={tvs({ ni: COLOURS.gray[270], tq: 'grey.300' })}
              mx={-5}
              px={5}
            >
              <Checkbox
                my={3}
                color={tvs({ ni: COLOURS.blue[600], tq: 'blue.275' })}
                value={filter.value}
                onChange={toggleSelectedType}
              >
                <Typography as='strong' fontWeight={tvs({ tq: '600' })}>
                  {filter.label}
                </Typography>
                <Typography
                  display='inline-block'
                  ml={3}
                  color={tvs({ ni: COLOURS.black, tq: 'blue.275' })}
                  fontWeight={tvs({ tq: '700' })}
                >
                  ({getTypeCount(filter.value)})
                </Typography>
              </Checkbox>
            </Box>
          ))}
        </CheckboxGroup>
      </FormControl>
    </Grid>
  );
};
